import {
    DadosBancariosSubcontaActions,
    DadosBancariosSubcontaActionsTypes,
} from "./dadosBancariosSubcontaActions"
import { DadosBancariosSubcontaModel } from "../models/dadosBancariosSubcontaModel"

const { CARREGAR, ATUALIZAR_CAMPO, TOKENS_CRIADOS } = DadosBancariosSubcontaActionsTypes

export function dadosBancariosSubcontaReducer(
    state: DadosBancariosSubcontaModel,
    action: DadosBancariosSubcontaActions
): DadosBancariosSubcontaModel {
    switch (action.type) {
        case CARREGAR:
            return { ...action.payload }

        case ATUALIZAR_CAMPO:
            return { ...state, [action.payload.campo]: action.payload.valor }

        case TOKENS_CRIADOS:
            return { ...state, possuiTokensCriadosIugu: true }

        default:
            return state
    }
}
